/* @flow */
import * as React from 'react';
// $FlowIssue: this will be resolved when we upgrade flow. React defs are out of date
import { createPortal } from 'react-dom';
import { alphabetize } from 'trustar/utils';
import { EnclaveIcon } from './EnclaveIcon.js';
import type { Map } from 'immutable';

import classnames from 'classnames/bind';

import s from './EnclaveMenu.styl';
const cx = classnames.bind(s);

const stopPropagation = e => e.stopPropagation();

export class EnclaveMenu extends React.Component {
  static defaultProps = {
    showDefault: true,
    title: 'Change Enclave Selection',
  };

  props: {
    position?: Object,
    className?: string,
    showDefault?: boolean,
    allowAnyOption?: boolean,
    enclavesMap: Map<any, any>,
    enclaveSelection: Map<any, any>,
    selectEnclave: Function,
    setEnclaveMenu: (x: boolean) => void,
    onClickOutside?: () => void,
    title: string,
  };

  render() {
    const {
      position,
      className,
      showDefault,
      enclavesMap,
      selectEnclave,
      allowAnyOption,
      setEnclaveMenu,
      enclaveSelection,
      onClickOutside,
    } = this.props;
    return (
      <div
        className={cx('enclaveDropdown', className)}
        style={position ? position : {}}>
        {onClickOutside && createPortal(
          <div className={cx('backdrop')} onClick={onClickOutside} />,
          document.querySelector('#portalTarget')
        )}
        <div onClick={stopPropagation} className={cx('inner')}>
          <div className={cx('menuTitle')}>
            {this.props.title}
          </div>
          {enclavesMap.toList().sort(alphabetize).map(enclave => {
            const current = enclaveSelection.get('enclaveId') === enclave.get('id');
            return (
              <div
                key={enclave.get('id')}
                onClick={() => (allowAnyOption || !current) && selectEnclave(enclave.get('name'), enclave.get('id'))}
                className={cx('menuOption', { current })}>
                <EnclaveIcon className={cx('EnclaveIcon')} enclave={enclave} />
                <div className={cx('name')}>
                  {enclave.get('name')}
                </div>
                {current && (
                  <span className={cx('checked')}>
                    <i className='fa fa-check'></i>
                  </span>
                )}
              </div>
            );
          })}
          {showDefault && (
            <div
              className={cx('menuOption', 'configureOption')}
              onClick={() => setEnclaveMenu(true)/* What's going on here? Why do this? */}>
              <i className={cx('fa fa-gear')}></i>Configure Default Enclave
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/EnclaveMenu.js